import React from 'react';
import styles from './index.module.less';
import { Button, Modal, Result } from 'antd';
import { useUserProvider } from '@/context/UserProvider';
import { useTranslation } from 'next-i18next';
import RegisterSuccessAlert from '../Common/RegisterSuccessAlert';
import { useRouter } from 'next/router';

const LoginResult = () => {
  const { t } = useTranslation('common');

  const { openLoginResult, onChangedLoginResult, isFirstLogin } = useUserProvider();
  const router = useRouter();
  return (
    <>
      {!isFirstLogin ? (
        <Modal
          className={styles.mainContainer}
          open={openLoginResult}
          onCancel={() => onChangedLoginResult(false)}
          destroyOnClose={true}
        >
          <div className={styles.homeContent} style={{ padding: '20px 24px' }}>
            <Result
              status="success"
              title={t('LoggedInSuccessfully')}
              // subTitle={t('InTheFutureYouCanVerifyThroughEmailCode_Desc')}
              extra={[
                <Button
                  type="primary"
                  key="console"
                  className={styles.loginFormButton}
                  onClick={() => {
                    onChangedLoginResult(false);
                  }}
                >
                  {t('Continue')}
                </Button>
              ]}
            />
          </div>
        </Modal>
      ) : (
        <RegisterSuccessAlert
          openType={openLoginResult}
          title={t('Sign Up successful')}
          desc={
            <>
              <div style={{ color: '#68F3F6' }}>{t('Get 1 Free Try-On.')}</div>
              <div style={{ color: 'var(--app-text-color)' }}>{t('Try on Trendy Hairstyles Now!')}</div>
            </>
          }
          btnTitle1={t('EXPLORE TRENDY STYLES')}
          handleCancel={() => {
            onChangedLoginResult(false);
          }}
          handleClick1={() => {
            router.push('/hairstyle');
            onChangedLoginResult(false);
          }}
        />
      )}
    </>
  );
};

export default LoginResult;
